import { memo, useEffect } from 'react';
import { Grid, useEventCallback } from '@mui/material';
import { useFormikContext } from 'formik';
import AccordionSearchPerson from './person';
import { RegistrationBewareFormVM, PersonVM } from 'mutation/view-models/registration-beware';
import ModalNewPerson from './modal-new-person';
import AccordionSubjectAttributes from './subject-attributes';
import AccordionChangeControlData from './change-control-data';
import AccordionPerson from 'shell/components/shared/person';

interface FormRegistrationBewareProps {
  initialValues: RegistrationBewareFormVM;
  data?: RegistrationBewareFormVM;
  onSearch: (values?: PersonVM | null) => Promise<RegistrationBewareFormVM>;
  isBeware?: boolean;
}

const FormRegistrationBewareComponent = ({
  onSearch,
  data,
  isBeware,
}: FormRegistrationBewareProps): React.ReactElement => {
  const formContext = useFormikContext<RegistrationBewareFormVM>();

  useEffect(() => {
    if (data) {
      formContext.setValues(data);
    }
  }, [data]);

  const onCloseModal = useEventCallback(() => {
    formContext.setValues({
      ...(formContext.values || {}),
      searchPerson: {
        openModal: false,
      },
    });
  });

  return (
    <>
      <Grid item xs={12}>
        <AccordionSearchPerson onSearch={onSearch} isBeware={isBeware} />
        {!formContext.values.person ||
        !formContext.values.citizenship ||
        !formContext.values.familyCoexistence ? undefined : (
          <AccordionPerson disabled />
        )}
        <AccordionChangeControlData />
        <AccordionSubjectAttributes isBeware={isBeware} />
      </Grid>
      <ModalNewPerson
        open={formContext.values?.person?.openModal || false}
        onClose={() => onCloseModal()}
      />
    </>
  );
};

FormRegistrationBewareComponent.displayName = 'Form Registration Beware component';

const FormRegistrationBeware = memo(FormRegistrationBewareComponent);

export default FormRegistrationBeware;
